import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgLoondienst = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      d="M20 17a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M20 17a6 6 0 0 1 6 6v10H14V23a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M17.017 11.947a3.02 3.02 0 0 0 6.006 0l.994.106a4.02 4.02 0 0 1-7.994 0z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M11.45 22h17.1a.57.57 0 0 1 .6.54v9.92a.57.57 0 0 1-.6.54h-17.1a.57.57 0 0 1-.6-.54v-9.92a.57.57 0 0 1 .6-.54"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M18.313 21.13a.9.9 0 0 0-.913.88l-1-.02a1.9 1.9 0 0 1 1.923-1.86h3.254a1.9 1.9 0 0 1 1.923 1.86l-1 .02a.9.9 0 0 0-.913-.88h-3.274"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      d="M11 28a2 2 0 1 0 0-4 2 2 0 0 0 0 4M29 28a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgLoondienst);

export default ForwardRef;
